// Construye el printInformation para el preview genérico de etiqueta/documento.
// Objeto NUEVO a propósito (no spread del estado previo): una preview por-caja
// (startBoxDocsChain) deja use_absolute_url/simpleClose/boxDocsQueue seteados, y
// heredarlos aquí hace que LabelView trate el path RELATIVO del blob como absoluto,
// cargando el <embed> contra el origen del WMS (fallback del SPA -> home) en vez de
// REACT_APP_PLATFORM_URL.
export const buildGenericPrintInfo = (title, path, type, { simpleClose = false } = {}) => ({
  title,
  type,
  file_path: path,
  // Reprints pass simpleClose so closing/printing the preview just dismisses the
  // dialog (operator stays on the order) instead of running the end-of-order
  // navigation. Default false keeps the generate-label flow's behavior.
  ...(simpleClose ? { simpleClose: true } : {}),
})
